import {
    SET_TITLE_SCOPE
} from "../../types";

const initialState = {
    scope: {
        primary: 'current',
        secondary: null
    },
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_TITLE_SCOPE:
            return {
                scope: { ...payload }
            };
        default:
            return state;
    }
}
